export default "__VITE_ASSET__DOpAKE3m__"